import { Message } from './message.interface';
import { Contact } from '../../contacts/contracts/contact.interface';

export enum ConversationStatus {
  TO_ASSIGN = 'TO_ASSIGN',
  ASSIGNED_PENDING = 'ASSIGNED_PENDING',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum ConversationPriority {
  DEFAULT = 'DEFAULT',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum MessageDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}


export interface Conversation {
  id: number;
  creationDate: string;
  status: ConversationStatus;
  fromNumber: string;
  tenantId: number;
  isReadOnly?: boolean;
  assignment?: any;
  hasQuote?: boolean;
  hasMedia?: boolean;
  hasBeenTouched?: boolean;
  mediaCount?: number;
  quoteCount?: number;
  notificationCount?: number;
  lastMessageUpdatedAt?: Date;
  lastMessageDirection?: MessageDirection;
  avatarId?: number;
  priority?: ConversationPriority;
  userIds?: number[];
  isWindowExpired?: boolean;

  notes?: string;
  recentPlates?: string[];

  lastMessage?: Message;
  contact?: Contact;
}
